import Link from 'next/link'
import React from 'react'
import styled from 'styled-components'

import Container from '../../components/Container'
import ExternalLink from '../../components/ExternalLink'
import GradientText from '../../components/GradientText'
import QuestionList from '../../components/QuestionList'
import { URL_APPLY_ARTIST, URL_DISCORD } from '../../config'
import { MEDIA_QUERY_DESKTOP } from '../../utils/media-query'

const Component = styled.div`
  padding: 2rem 0;
  border-top: 1px solid rgba(255, 255, 255, .15);

  ${MEDIA_QUERY_DESKTOP} {
    padding: 4rem 0;
  }
`

const Title = styled.h2``

/**
 * - What is the smart contract address?
 * - How do I access VOID?
 * - I'm an artist, how can we collaborate?
 * - More question? Join our community on Discord
 */

const questions = [{
  title: 'How do I mint?',
  content: (
    <>
      Only holders of Objects (or Sequences) can access VOID and mint.
    </>
  )
}, {
  title: 'How do I access VOID?',
  content: (
    <>
      Only holders of Objects (or Sequences) can access VOID.
    </>
  )
}, {
  title: 'How are the NFTs (and visuals) stored?',
  content: (
    <>
      NFTs on Triptcip are basically arrays of shaders, mapped to audio positions. Stored in JSON files.
      <br />
      <br />
      Triptcip serves the files from AWS (S3, CloudFront, Imgix) for speed reasons and kept on IPFS for that "permanent" feel good.
    </>
  )
}, {
  title: 'What is Triptcip\'s stance on ETH\'s energy consumption?',
  content: (
    <>
      Thanks to blockchain, a project like Triptcip is able to operate successfully.
      Blockchain technology is unfortunately also what causes significant energy consumption.
      We are aware of this.
      While there are no direct solutions yet, we'd like to be as transparent as possible about it, and show you our perspective on NFTs and its energy consumption.
      <br />
      <br />
      <strong>
        ETH 2.0
      </strong>
      <br />
      <br />
      With the current Ethereum network, when someone makes, buys, or sells an NFT, they’re responsible for some of the emissions generated by miners (proof of work).
      <br />
      <br />
      Triptcip and many others on the Ethereum network are patiently waiting for the launch of ETH 2.0.
      It's main feature: proof of stake, will significantly reduce energy consumption (and drop those ridiculous gasfees).
      Proof of stake has basically no emissions.
      Until then, Tripticip will keep operating on the Ethereum network.
      <br />
      <br />
      <strong>
        Culpability
      </strong>
      <br />
      <br />
      Figuring out the culpability of NFTs is a little like calculating a share of emissions from a commercial plane. You can look at each NFT transaction on the blockchain and track how much energy consumption takes place. Whether you decide to purchase the plane ticket, it will fly anyways. The same counts for the Ethereum network, miners will keep on mining, regardless of how many NFT transactions take place. Now we're not trying to sugar coat things here. We're aware that we, undeniably, are part of this energy consumption.
      <br />
      <br />
      <strong>
        Purchasing Carbon Offset
      </strong>
      <br />
      <br />
      <p>
        While we patiently wait for ETH 2.0, we will buy carbon offsets by using
        {' '}
        <ExternalLink href='https://www.aerial.is'>
          Aerial
        </ExternalLink>.
      </p>
    </>
  )
}, {
  title: 'I\'m an artist, how can I get involved?',
  content: (
    <>
      We're hand picking artists that match with our taste of sound, vision of experimentation and have an engaging audience.
      If you believe you match those requirements,
      {' '}
      <Link
        href={URL_APPLY_ARTIST}
        passHref
      >
        <a
          target='_blank'
          rel='noreferrer'
        >
          feel free to submit our artist form.
        </a>
      </Link>
    </>
  )
}, {
  title: 'Have more questions?',
  content: (
    <>
      <Link
        href={URL_DISCORD}
        passHref
      >
        <a
          target='_blank'
          rel='noreferrer'
        >
          <GradientText variant={GradientText.VARIANT_PRIMARY}>
            <strong>
              Join our community on Discord
            </strong>
          </GradientText>
        </a>
      </Link>
      {' '}
      and shoot.
    </>
  )
}]

const Faq = () => {
  return (
    <Component>
      <Container>
        <Title>
          FAQ
        </Title>
        <QuestionList questions={questions} />
      </Container>
    </Component>
  )
}

export default Faq
